// material
import { useEffect } from 'react';
import { getI18n } from 'react-i18next';

// ----------------------------------------------------------------------

export default function LanguageDetector() {
  useEffect(() => {
    const languageLocalStorage = localStorage.getItem('language');
    if (languageLocalStorage && ['es', 'en'].includes(languageLocalStorage)) {
      getI18n().changeLanguage(languageLocalStorage);
    } else {
      if (navigator.languages.length > 0) {
        if (navigator.languages[0] === 'es') {
          getI18n().changeLanguage('es');
          localStorage.setItem('language', 'es');
        } else if (navigator.languages[0].split('-')[0] === 'es') {
          getI18n().changeLanguage('es');
          localStorage.setItem('language', 'es');
        } else {
          getI18n().changeLanguage('en');
          localStorage.setItem('language', 'en');
        }
      }
    }
  }, []);
  return <div></div>;
}
